<template>
  <hm-content title="">
    <div class="flex flex-between mb20">
      <el-button type="primary" size="small" @click="add"
        >添加手动结算</el-button
      >
      <div>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="请选择时间段"
          end-placeholder="请选择时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10 time"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <div class="mb10">
        结算记录{{ total }}条，订单总佣金
        <span class="primary">¥{{ ToFixed(platformPromotionAmount, 2) }}</span
        >，支出总佣金<span class="primary"
          >¥{{ ToFixed(promotionAmount, 2) }}</span
        >，平台总利润<span class="primary"
          >¥{{ ToFixed(profitAmount, 2) }}</span
        >
      </div>
      <div class="table">
        <el-table
          :data="list"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="table"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="结算时间"
            prop="handleTime"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            label="结算周期"
            prop="mobile"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            label="合计结算人数"
            prop="memberDistinctNum"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="platformPromotionAmount"
            label="合计总佣金"
          >
            <template slot-scope="scope">
              ￥ {{ ToFixed(scope.row.platformPromotionAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="promotionAmount"
            label="结算支出佣金"
          >
            <template slot-scope="scope">
              ￥ {{ ToFixed(scope.row.promotionAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="profitAmount"
            label="合计利润"
          >
            <template slot-scope="scope">
              {{ ToFixed(scope.row.profitAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="orderNum"
            label="合计订单个数"
          >
          </el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button type="text" size="small" @click="detail(scope.row)">
                  查看结算订单
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1000px"
      :visible.sync="dialogVisible"
    >
      <el-dialog
        width="1200px"
        title="订单详情"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="mb10">
          符合条件的订单数{{ row.orderNum }}合计总佣金{{
            ToFixed(row.platformPromotionAmount / 100, 2)
          }}元，支出总佣金{{ ToFixed(row.promotionAmount / 100, 2) }}元
        </div>
        <div class="table">
          <el-table
            :data="orderDetailList"
            style="width: 100%"
            stripe
            size="small"
            border
            ref="table"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageOrder - 1) * pageSizeOrder + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="商品名称"
              prop="goodsName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="平台"
              prop="platformType"
            >
              <template slot-scope="scope">
                {{ scope.row.platformType === "pdd" ? "拼多多" : "京东" }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="订单状态"
              prop="orderStatusDesc"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="平台佣金"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.platformPromotionAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderAmount"
              label="推广者佣金"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.promotionAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="platformPromotionRate"
              label="平台利润"
            >
              <template slot-scope="scope">
                ￥
                {{
                  ToFixed(
                    (scope.row.platformPromotionAmount -
                      scope.row.promotionAmount) /
                      100,
                    2
                  )
                }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="platformFeeAmount"
              label="平台结算时间"
            >
            </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="platformFeeAmount"
              label="支出技术服务费"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.platformFeeAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="订单号"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalOrder"
            @current-change="pagingOrder"
            @size-change="handleSizeChangeOrder"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageOrder"
          ></el-pagination>
        </div>
      </el-dialog>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <div class="bd">
          <div class="flex">
            <div class="ste">
              <div class="flex item-center">
                <span class="yuan">1</span>
                <span>核查订单的款项是否有误</span>
              </div>
            </div>
            <div class="sanjiao"></div>
          </div>
          <div class="order-list">
            <el-table
              :data="awaitOrderList"
              style="width: 100%"
              stripe
              size="small"
              border
              ref="table"
            >
              <el-table-column
                header-align="center"
                align="center"
                label="待结算合计人数"
                prop="memberDistinctNum"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="合计总佣金"
                prop="platformPromotionAmount"
              >
                <template slot-scope="scope">
                  {{ ToFixed(scope.row.platformPromotionAmount / 100, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="结算支出佣金"
                prop="promotionAmount"
              >
                <template slot-scope="scope">
                  {{ ToFixed(scope.row.promotionAmount / 100, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="合计利润"
              >
                <template slot-scope="scope">
                  {{
                    ToFixed(
                      (scope.row.platformPromotionAmount -
                        scope.row.promotionAmount -
                        scope.row.platformFeeAmount) /
                        100,
                      2
                    )
                  }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="合计订单个数"
                prop="orderNum"
              ></el-table-column>

              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      type="text"
                      size="small"
                      @click="details(scope.row)"
                    >
                      查看结算订单
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div class="flex">
            <div class="ste">
              <div class="flex item-center">
                <span class="yuan">2</span>
                <span>确认打款</span>
              </div>
            </div>
            <div class="sanjiao"></div>
          </div>
          <div class="order-list flex item-center">
            <div class="mr10">
              打款方式
            </div>
            <div>
              <el-select
                clearable
                v-model="searchCondition.platformType"
                placeholder="请选择平台类型"
                size="small"
                class="mr10 flex-1"
                filterable
              >
                <el-option label="拼多多" value="pdd"></el-option>
                <el-option label="京东" value="jd"></el-option>
              </el-select>
            </div>
          </div> -->
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" @click="confirm">
          确认打款</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="结算订单"
      width="1200px"
      :visible.sync="dialogVisibleDetails"
    >
      <div>
        <div class="mb10">
          符合条件的订单数{{ row.orderNum }}合计总佣金{{
            ToFixed(row.platformPromotionAmount, 2)
          }}元，支出总佣金{{ ToFixed(row.promotionAmount, 2) }}元
        </div>
        <div class="table">
          <el-table
            :data="orderDetailList"
            style="width: 100%"
            stripe
            size="small"
            border
            ref="table"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageOrder - 1) * pageSizeOrder + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="商品名称"
              prop="goodsName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="平台"
              prop="platformType"
            >
              <template slot-scope="scope">
                {{ scope.row.platformType === "pdd" ? "拼多多" : "京东" }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="订单状态"
              prop="orderStatusDesc"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="平台佣金"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.platformPromotionAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderAmount"
              label="推广者佣金"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.promotionAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="platformPromotionRate"
              label="平台利润"
            >
              <template slot-scope="scope">
                ￥
                {{
                  ToFixed(
                    (scope.row.platformPromotionAmount -
                      scope.row.promotionAmount) /
                      100,
                    2
                  )
                }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="platformFeeAmount"
              label="平台结算时间"
            >
            </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="platformFeeAmount"
              label="支出技术服务费"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.platformFeeAmount / 100, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="订单号"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalOrder"
            @current-change="pagingOrder"
            @size-change="handleSizeChangeOrder"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageOrder"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { ToFixed } from "@/utils/utils";

export default {
  data() {
    return {
      row: {},
      totalOrder: 0,
      currentPageOrder: 1,
      pageSizeOrder: 10,
      orderDetailList: [],
      innerVisible: false,
      dialogVisibleDetails: false,
      awaitOrderList: [],
      ToFixed,
      ruleForm: {
        brandName: "",
        brandCode: "",
        brandInitials: "",
        logoPic: ""
      },
      rules: {
        logoPic: {
          required: false,
          message: "请选择品牌LOGO！",
          trigger: "blur"
        }
      },
      title: "",
      dialogVisible: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      platformFeeAmount: 0,
      platformPromotionAmount: 0,
      profitAmount: 0,
      promotionAmount: 0,
      orderIds: "",
      type: ""
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    detail(row) {
      this.dialogVisibleDetails = true;
      this.row = row;
      this.currentPageOrder = 1;
      this.pageSizeOrder = 10;
      this.type = "list";
      this.queryOrderList();
    },
    async confirm() {
      const { code } = await this.$store.dispatch("taokeHandleOrder");
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.dialogVisible = false;
        this.queryList();
      }
    },
    add() {
      this.type = "add";
      this.title = "手动结算";

      this.queryAwaitOrder();
    },
    details(row) {
      this.type = "";
      this.row = row;
      this.currentPageOrder = 1;
      this.pageSizeOrder = 10;
      this.orderIds = row.orderIds;
      this.queryOrderList();
      this.innerVisible = true;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryOrderList() {
      const params = {
        pageSize: this.pageSizeOrder,
        pageNo: this.currentPageOrder
      };
      if (this.type === "list") {
        params.handleRecordId = this.row.id;
      } else {
        params.orderIds = this.orderIds.split(",");
      }

      const { code, result } = await this.$store.dispatch(
        "taokeHandleOrderInfoList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.orderDetailList = records;
        this.totalOrder = total;
      }
    },
    async queryAwaitOrder() {
      const { code, result } = await this.$store.dispatch(
        "taokeAwaitHandleOrderList"
      );
      if (code === "0") {
        if (!result.orderNum) {
          this.$message({
            message: "暂无可结算订单！",
            type: "warning"
          });
          return;
        }
        this.dialogVisible = true;
        this.awaitOrderList = [result];
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "taokeHandleOrderList",
        params
      );
      if (code === "0") {
        const {
          page,
          platformFeeAmount,
          platformPromotionAmount,
          profitAmount,
          promotionAmount
        } = result;
        this.platformFeeAmount = platformFeeAmount;
        this.platformPromotionAmount = platformPromotionAmount;
        this.profitAmount = profitAmount;
        this.promotionAmount = promotionAmount;
        const { total, records } = page;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingOrder(page) {
      this.currentPageOrder = page;
      this.queryOrderList();
    },
    handleSizeChangeOrder(size) {
      this.currentPageOrder = 1;
      this.pageSizeOrder = size;
      this.queryOrderList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.sanjiao {
  width: 0;
  height: 0;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  border-left: 30px solid #eee;
}
.ste {
  background: #eee;
  padding: 0 20px;
  // width: 200px;
  height: 36px;
  line-height: 36px;

  .yuan {
    width: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 50%;
    background: #000;
    color: #fff;
    text-align: center;
    margin-right: 5px;
  }
}
.bd {
  border: 1px solid #ddd;
}
.order-list {
  padding: 28px;
}
</style>
